module.exports = __webpack_public_path__ + "static/media/fr.80949ae9.svg";